/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OtpType {
  SMS_OTP = 'SMS_OTP',
  EMAIL_OTP = 'EMAIL_OTP',
}
